import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';
import api from 'http';
import React, { useEffect, useState } from 'react'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';

const PaymentsPage = () => {
    const [loader, setLoader] = useState(false)

    useEffect(() => {

        (async () => {
            try {
                setLoader(true)
                const pathname = window.location.href
                const segment = pathname.substring(pathname.lastIndexOf('/') + 1);
                const typesOfServices = await api.get(`${process.env.REACT_APP_TC_PMS}/api/StripeApi/FetchTransactionReceipt/${segment}`);// this API only run one time 
                // window.open(typesOfServices.data.dataModel);
                // opentab(typesOfServices.data.dataModel)
                window.location.assign(typesOfServices.data.dataModel)

            } catch (error) {
                ErrorHandlingMessage(error)
            } finally { setLoader(false) }

        })();
    }, [])
    return (
        <div>
            {loader && <FullPageLoader allowFullScreen />}
            {/* <CustomButtonNew text="go" onClick={opentab} /> */}
        </div>
    )
}

export default PaymentsPage